<template>
  <div style="display: inline;">
    <parameter-inline
      is-root
      editable
      move-to-body
      use-vendor-code
      bold-selected
      v-model="innerModel"
      :id="id"
      :root-param="rootParam"
      :context-trigger="triggerEl"
      :show-custom="false"
      :maintain-string-value="true"
    />
    <q-icon
      v-if="showClearIcon"
      name="arrow_back"
      size="18px"
      color="grey-7"
      class="pointer hover-green q-ml-sm"
      style="align-self: baseline"
      title="clear"
      @click="onClear"
    />
  </div>
</template>

<script lang="ts">
import _ from "lodash";
import { reactive } from "vue";
import { Component, Emit, Prop, Vue, Watch } from "vue-facing-decorator";
import { V2ParameterValueType } from "../../../models/etc/parameter-types";
import { ParameterInstanceContainerType, V2FieldValueDisplayType, V2RecordAxisType } from "../../../models/etc/types";
import { instanceForFilterFromInstance, mapCreateContainerToInstance } from "../../../models/helpers/parameter-helpers";
import { SelectionStorageItemNameFilterDto } from "../../../models/interfaces/entity-settings/filters/filters";
import { ParameterInstance, ParameterInstanceContainer } from "../../../models/interfaces/parameters/parameter-models";
import { storagePositionsStore } from "../../../store/storage/storage-positions";

@Component({
  name: "StorageItemFilterWrapper",
  emits: ['update:modelValue']
})
export default class StorageItemFilterWrapper extends Vue {
  // v-model
  @Prop({ default: undefined })
  modelValue!: SelectionStorageItemNameFilterDto;
  @Emit("update:modelValue") emitModelValue(
    arg: SelectionStorageItemNameFilterDto
  ) {
    return arg;
  }

  @Prop({ default: undefined })
  rootParam!: any;
  @Prop({ default: undefined })
  triggerEl!: any;
  @Prop({ default: undefined })
  id!: any;
  @Prop({ default: true })
  UseVendorCode!: boolean;
  @Prop({ default: false })
  showClearIcon!: boolean;

  storage_pos: any = undefined;

  // model data
  innerModel: ParameterInstanceContainer[] = reactive([]);

  created() {
    this.storage_pos = storagePositionsStore();
    this.updateInnerModel();
  }

  get model_value_mut() {
    return _.cloneDeep(this.modelValue)
  }

  @Watch('model_value_mut', { deep: true })
  model_watcher(newv: any, oldv: any) {
    if (!this.modelValue || !this.storage_pos || _.isEqual(newv, oldv)) { return }
    this.updateInnerModel();
  }

  updateInnerModel() {
    const res: ParameterInstanceContainer[] = []
    if (this.UseVendorCode) {
      const vcode_cell = {
        Type: ParameterInstanceContainerType.SingleInstance,
        Instance: {
          TemplateId: 999,
          Unremovable: true,
          ValueType: V2ParameterValueType.String,
          StringValue: this.modelValue.VendorCode,
          NumberValue: null,
          DateValue: null,
          BoolValue: null,
          ValueSet: null,
          SelectedValue: null,
          ValueDisplayType: V2FieldValueDisplayType.Inline,
          Name: this.$t('sku'),
          Id: 0,
          Round: 2,
          RecordAxisType: V2RecordAxisType.Horizontal,
          RecordFields: [],
        } as ParameterInstance,
        ListTitle: null,
      } as ParameterInstanceContainer;
      res.push(vcode_cell)
    }
    this.modelValue.Container && res.push(this.modelValue.Container)
    this.innerModel = reactive(res);
  }

  onClear() {
    if (this.storage_pos?.currentItemNameContainer && this.storage_pos?.currentItemNameContainer.ParameterContainer) {
      const res: ParameterInstanceContainer[] = []
      if (this.UseVendorCode) {
        const vcode_cell = {
          Type: ParameterInstanceContainerType.SingleInstance,
          Instance: {
            TemplateId: 999,
            Unremovable: true,
            ValueType: V2ParameterValueType.String,
            StringValue: "",
            NumberValue: null,
            DateValue: null,
            BoolValue: null,
            ValueSet: null,
            SelectedValue: null,
            ValueDisplayType: V2FieldValueDisplayType.Inline,
            Name: this.$t('sku'),
            Id: 0,
            Round: 2,
            RecordAxisType: V2RecordAxisType.Horizontal,
            RecordFields: [],
          } as ParameterInstance,
          ListTitle: null,
        } as ParameterInstanceContainer;
        res.push(vcode_cell)
      }
      res.push(mapCreateContainerToInstance(
        this.storage_pos?.currentItemNameContainer.ParameterContainer,
        true
      )[0])
      this.innerModel = reactive(res);
    }
  }

  @Watch("innerModel", { deep: true })
  theModelWatcher(val: ParameterInstanceContainer[]) {
    const mv = this.modelValue;
    const newval = instanceForFilterFromInstance(_.cloneDeep(val))

    if (this.UseVendorCode) {
      mv.VendorCode = newval[0].Instance?.StringValue || ''
      mv.Container = newval[1];
    } else {
      mv.Container = newval[0];
    }
    this.emitModelValue(mv);
  }
}
</script>
